<template>
    <div id="table-content" class="table-area">
        <ui-load-success
            v-if="loader.overlay"
            :loading="loader.overlayLoading"
            :success="loader.overlaySucess"
        />

        <actions-rules-modal
            :name="name"
            :modal-name="modalName"
            :stages="options.stages"
            :actions="options.actions"
        />

        <ui-modal-message
            :name="deleteModalName"
            title="Deseja realmente excluir essa Regra de Ação?"
            text="Cuidado, esta ação não poderá ser desfeita."
            btn-type="danger"
            btn-text="Confirmar"
            icon="fal fa-trash-alt"
            color-circle="danger"
            icon-circle
            @action="deleteTableItem"
        />

        <div class="table-action">
            <perfect-scrollbar>
                <ui-table
                    :name="name"
                    :columns="table.columns"
                    :data="table.data"
                    :loading="table.loader"
                    :table-header-fixed="false"
                    :is-fixed-list="false"
                    :last-col-fixed="false"
                    :select-column-menu="false"
                    tr-component="rules/actions-rules-table/components/actions-rules-table-line"
                    not-found-text="Não foi possível encontrar nenhuma regra."
                    not-found-icon="fa fa-file-contract"
                    custom-load-area
                    disable-ref
                />
            </perfect-scrollbar>
        </div>
    </div>
</template>

<script>
	import { uiTable } from '@/components/ui'
	import { uiModalMessage } from '@/components/ui/modal'
	import { uiLoadSuccess } from '@/components/ui/overlays'
	import ActionsRulesModal from './components/actions-rules-modal/index.vue'

	import { funnel, action, configuration } from '@/services/axios'

	import { makeTable, makeColumns } from './data'

	const defaultLoader = () => ({
		overlay: false,
		overlayLoading: true,
		overlaySucess: true,
	})

	const defaultoOptions = () => ({
		stages: [],
		actions: [],
	})

	export default {
		name: 'actions-rules-table',

		components: {
			uiModalMessage,
			uiLoadSuccess,
			ActionsRulesModal,
			uiTable,
		},

		props: {
			name: {
				type: String,
				required: true,
			},
		},

		data() {
			return {
				table: {
					data: [],
					columns: [],
					loader: false,
					canSubmit: true,
				},
				options: { ...defaultoOptions() },
				loader: { ...defaultLoader() },
				lines: [],
			}
		},

		computed: {
			modalName() {
				return this.name + '-modal'
			},

			deleteModalName() {
				return this.name + '-delete-modal'
			},

			canSubmit() {
				return true
			},
		},

		watch: {
			value(value) {
				if (value) this.table = value
			},

			table(value) {
				this.$emit('input', value)
			},
		},

		async created() {
			this.$root.$on(`${this.name}:update`, async (payload) => {
				this.lines = await this.getActions()
				const index = this.lines.findIndex((line) => line.id == payload.id)
				if (index != -1) this.lines[index].highlight = true
				this.updateTable()
			})

			this.$root.$on(`${this.name}:edit`, async (line) => {
				this.$root.$emit(`modal-open-${this.modalName}`, line)
			})

			this.$root.$on(`${this.name}:delete`, async (paymentItem) => {
				const config = { formdata: { paymentItem } }
				this.$root.$emit('modal-msg-open-' + this.deleteModalName, config)
			})

			this.table.loader = true

			this.lines = await this.getActions()
			this.options.stages = await this.getStages()
			this.options.actions = await this.getActionsSettings()

			this.updateTable()
			this.table.loader = false
		},

		mounted() {
			this.$emit('input', this.table)
		},

		destroyed() {
			this.$root.$off(`${this.name}:update`)
			this.$root.$off(`${this.name}:delete-payment`)
		},

		methods: {
			copyObject(object) {
				return JSON.parse(JSON.stringify(object))
			},

			async getActions() {
				return (
					await action.getAllV2('', {
						groupby: 'funnel_stage_id,funnel_stage_status_id,id',
						orderby: 'funnel_stage_status_id',
					})
				).data.data
			},

			async getStages() {
				return (await funnel.getStagesV2()).data.data
			},

			async getActionsSettings() {
				return (await configuration.getConfig('funnelActionsSettings')).data.value_long
			},

			async deleteTableItem(item) {
				try {
					this.loader.overlay = true
					this.loader.overlayLoading = true

					await action.deleteV2('', item.paymentItem.id)

					this.lines = await this.getActions()
					this.updateTable()

					setTimeout(() => {
						this.loader.overlayLoading = false
						this.loader.overlaySucess = true
						setTimeout(() => {
							this.loader.overlay = false
						}, 500)
					}, 500)

					//...
				} catch (error) {
					this.loader.overlaySucess = false
					setTimeout(() => {
						this.loader.overlay = false
					}, 1000)
				}
			},

			updateTable() {
				this.table.columns = makeColumns()
				this.table.data = makeTable(
					this.lines,
					this.name,
					this.options.stages,
					this.options.actions,
				)
				this.table.canSubmit = this.canSubmit
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
